import { render, staticRenderFns } from "./BaseVideoPlayer.vue?vue&type=template&id=4482e2d2&scoped=true"
import script from "./BaseVideoPlayer.vue?vue&type=script&lang=js"
export * from "./BaseVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./BaseVideoPlayer.vue?vue&type=style&index=0&id=4482e2d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4482e2d2",
  null
  
)

export default component.exports